import { stationMethods } from "@swa-ui/itinerary";

/**
 * getAirportGroups
 *
 * Return value: array of all multiSelectGroup airport groups info.
 */

export const getAirportGroups = () =>
  stationMethods.getStations().filter((station) => station?.multiSelectGroup === true);

/**
 * getAirportGroup
 *
 * Parameter Example: ' ['MIA', 'FLL']
 * Return value: AirportGroup info for given station codes. 'undefined' will be return if station codes are invalid.
 */
export const getAirportGroup = (stationCodes) =>
  getAirportGroups().find((areaInfo) =>
    stationCodes.every((stationCode) => areaInfo.children.includes(stationCode))
  );

/**
 * getStationAreaGroupDisplayName
 *
 * Parameter Example: ['MIA', 'FLL]
 * Return value: multiSelectGroupDisplayName for given station codes. 'undefined' will be return if station codes are invalid.
 */
export const getAirportGroupDisplayName = (stationCodes) => {
  const station = getAirportGroup(stationCodes);

  return station?.multiSelectGroup ? station?.multiSelectGroupDisplayName : undefined;
};

/**
 * getAirportGroupsId
 *
 * Parameter Example: ['MIA', 'FLL]
 * Return value: id for given station codes. 'undefined' will be return if station codes are invalid.
 */

export const getAirportGroupId = (stationCodes) => {
  const station = getAirportGroup(stationCodes);

  return station?.multiSelectGroup ? station?.id : undefined;
};

/**
 * getStationAreaName returns the station area name for the given airport group id.
 *
 * Parameter example: 'SFC'
 * Return value: San Francisco Area Airports
 *
 */
export const getStationAreaName = (stationId) => stationMethods.getAreaName(stationId);
